const preloadImage = (src: string) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    // eslint-disable-next-line fp/no-mutation
    img.src = src;
    // eslint-disable-next-line fp/no-mutation
    img.onload = resolve;
    // eslint-disable-next-line fp/no-mutation
    img.onerror = reject;
  });

export const preloadImages = (srcList: string[]) => Promise.all(srcList.map(preloadImage));
